import React, { FC } from "react";
import DateTimeRangePicker from "@wojtekmaj/react-datetimerange-picker";
import "@wojtekmaj/react-datetimerange-picker/dist/DateTimeRangePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { IInputProps } from "../../../modules/form";

interface IInputDateTimeProps extends IInputProps {
  minDate?: any;
  isShowTime?: boolean;
}

export const InputDateRangePicker: FC<IInputDateTimeProps> = (props) => {
  const { value, onChange, minDate } = props;

  return (
    <DateTimeRangePicker
      className="InputDateTimeRange"
      value={value}
      locale="vi-VN"
      format="dd/MM/yyyy"
      onChange={onChange}
      minDate={minDate || null}
    />
  );
};
